import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-system-section',
  templateUrl: './system-section.component.html',
  styleUrls: ['./system-section.component.css']
})
export class SystemSectionComponent implements OnInit {

  clickValueItem(event){
    if(event.target.closest(".value")){
      let coreValueItemsContainer = event.target.closest(".system-items");
      let valueItem = event.target.closest(".value");

      let visibleItem = coreValueItemsContainer.querySelector(".visible-value-pop-up");

      if(visibleItem && valueItem!==visibleItem){
        visibleItem.classList.remove("visible-value-pop-up"); 
        visibleItem.classList.remove("active-item");      
      }  

        valueItem.classList.toggle("visible-value-pop-up");
        valueItem.classList.toggle("active-item");

    }
  }

  constructor() { }

  ngOnInit(): void {
  }

}
